import React from 'react';

const Experience = ({item}) => {
  return (
    <div className="grid-container">{ item.title } | { item.description }</div>
  );
};

export default Experience;
